import React from "react";

export const SearchMatchCtx = React.createContext<string>("");
SearchMatchCtx.displayName = "components/RuleGraphFullRelease/SearchMatchCtx";
export const useSearchMatchCtx = (): string => React.useContext(SearchMatchCtx);
